import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentAccountId, tokenSelector } from 'reducers/userAuthSlice';
import { CURRENT_ACCOUNT_ID, INTENDED_LOCATION } from 'constants/localStorageConstants';
import { findAccountIdFromUrl } from 'utils/urlHelpers';

const RequireAuthentication = ({ children }) => {
	const isLoggedIn = useSelector(tokenSelector);
	const dispatch = useDispatch();
	const location = useLocation();
	const { pathname, search } = location;
	const intendedLocation = localStorage.getItem(INTENDED_LOCATION);

	//If the user visits a link without being logged in, save their intended location to redirect to after logging in (PostCognito.js)
	if (!isLoggedIn && !intendedLocation) {
		const disallowedPathnames = ['/', '/login', '/logout', '/post-login-flow']; //Do not set INTENDED_LOCATION to these values to avoid user getting stuck on these routes
		if (!disallowedPathnames.includes(pathname)) {
			localStorage.setItem(INTENDED_LOCATION, pathname + search);
			const accountId = findAccountIdFromUrl(pathname);
			if (accountId) {
				dispatch(setCurrentAccountId(accountId));
				localStorage.setItem(CURRENT_ACCOUNT_ID, accountId);
			}
		}
	}

	return isLoggedIn ? children : <Navigate to='/login' state={{ from: location }} />;
};

export default RequireAuthentication;
